<template>
    <div class="menu d-flex justify-content-around py-4">
        <a href="/">
            <i class="fas fa-home"></i>
        </a>
        <a href="{{catalogo}}" target="_blank">
            <i class="fas fa-clipboard-list"></i>
        </a>
        <a href="/favoritos">
            <i class="far fa-heart"></i>
        </a>
        <a href="/perfil">
            <i class="fas fa-user"></i>
        </a>
    </div>
</template>

<script>

export default {
    data() {
        return {
            catalogo: process.env.MIX_CATALOGO_URL
        };
    },
    methods: {

    },
    mounted: function () {

    }
};
</script>
